import React, {Component} from 'react'
import {Query} from 'react-apollo'
import DocumentTitle from 'react-document-title'
import assign from 'lodash/assign'
import get from 'lodash/get'

import {Loader} from '../containers/Loader'
import {BOARDS_PER_PAGE} from '../config'
import DASHBOARD_QUERY from '../graphql/DashboardQuery.graphql'
import Boards from './Boards'
import {getPageTitle, getUser} from '../utils'
import cn from 'classnames'
import EmptyState from './EmptyState'
import CreateBoard from './Board/CreateBoard'
import MarkJellyfishV2ColorImage from "../assets/mark-jellyfish-v2-color.png";
// import SlackJellyCommandImage from "../assets/slack-jelly-command.png";
// import OpenSlackImage from "../assets/open_slack@2x.png";

class Dashboard extends Component {
    state = {
        active: true,
        alertVisible: false
    }

    handleChangeActive = (e, active) => {
        e.preventDefault()
        this.setState({active})
    }

    handleAlertDismiss() {
        // console.log('test');
        // this.setState({ alertVisible: false });
    }

    render() {
        const {active} = this.state
        return (
            <DocumentTitle title={getPageTitle('Home')}>
                <Query
                    query={DASHBOARD_QUERY}
                    variables={{
                        first: BOARDS_PER_PAGE,
                        isArchived: active,
                    }}
                >
                    {({loading, error, data, fetchMore, refetch}) => {
                        const pageInfo = get(data, 'getBoards.pageInfo', {})
                        // if (error) return `Error! ${error.message}`;
                        // if (error) this.state.alertVisible = true;
                        return (
                            <div className="container">

                                {error ? (
                                    <div className="mt-3">
                                        <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                            <strong>Sad Jellyfish 😫.</strong> We're are sorry, there was an error: ${error.message}, please try again.
                                            {/*<button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={this.handleAlertDismiss.bind(this)}>*/}
                                                {/*<span aria-hidden="true">&times;</span>*/}
                                            {/*</button>*/}
                                        </div>
                                    </div>
                                ) : null}

                                {loading ? null : data && data.getBoards.edges.length === 0 && active  ?

                                    //Empty State
                                    <div className="app flex-row ">
                                        <div className="container align-items-center">
                                            <div className="row">&nbsp;</div>
                                            <div className="row">&nbsp;</div>
                                            <div className="justify-content-center row ">
                                                <div className="col-md-6">
                                                    <div className="card-group">
                                                        {/*<div className="p-4 card">*/}
                                                        {/*<div className="card-body"><h1>Login</h1><p className="text-muted">Sign In to your account</p></div>*/}
                                                        {/*</div>*/}
                                                        <div className="py-3 card">
                                                            <div className="card-body">
                                                                <div>
                                                                    {/*<Mark/>*/}
                                                                    <div className="text-center"><img alt="Logo" className="d-md-down-none text-center" src={MarkJellyfishV2ColorImage} height="172" width="172"/></div>
                                                                    <div>&nbsp;</div>
                                                                    <div className="text-center"><h2>Welcome to Jellyfish</h2></div>
                                                                    {/*<div>&nbsp;</div>*/}
                                                                    <div className="text-center pt-2">To host a Q&A, start by creating a session</div>
                                                                    <div className="pt-2"></div>
                                                                    <div>&nbsp;</div>
                                                                    <div className="">
                                                                        <CreateBoard isStartButton={true} onCloseRefreshHandler={() => refetch()} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                :

                                    <div>
                                        {/*<div className="d-flex flex-row  align-items-center justify-content-between my-3">*/}
                                        <div className="row my-4">
                                            {/*<div className="d-sm-down-none col-1">*/}
                                            {/*/!*<div className="col-sm-3 col-md-1">*!/*/}
                                            {/*    <h4>Sessions</h4>*/}
                                            {/*</div>*/}
                                            <div className="col-3">
                                                <CreateBoard onCloseRefreshHandler={() => refetch()} />
                                                {/*{getUser().email && getUser().email.indexOf('farnell') !== -1 && ( <CreateBoard onCloseRefreshHandler={() => refetch()} /> )}*/}
                                            </div>
                                            <div className="col-9 col-md-9 text-right">
                                            {/*<div className="col-sm-6 col-md-8 text-right">*/}
                                                <div aria-label="First group" role="group" className="mx-2 btn-group">
                                                    <button type="button" className={cn('btn btn-outline-primary', active === true && 'active')} onClick={e => this.handleChangeActive(e, true)}>Active</button>
                                                    <button type="button" className={cn('btn btn-outline-primary', active === false && 'active')} onClick={e => this.handleChangeActive(e, false)}>Archived</button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row d-flex justify-content-center"></div>

                                        <Boards
                                            edges={get(data, 'getBoards.edges', [])}
                                            pageInfo={pageInfo}
                                            onLoadMore={() =>
                                                fetchMore({
                                                    variables: {
                                                        after: pageInfo.endCursor,
                                                        first: BOARDS_PER_PAGE,
                                                    },
                                                    updateQuery: (prev, {fetchMoreResult}) => {
                                                        if (!fetchMoreResult) return prev
                                                        // Merge the edges together, but keep the new pageInfo
                                                        return assign({}, prev, {
                                                            getBoards: {
                                                                pageInfo: fetchMoreResult.getBoards.pageInfo,
                                                                edges: [...prev.getBoards.edges, ...fetchMoreResult.getBoards.edges],
                                                            },
                                                        })
                                                    },
                                                })
                                            }
                                        />
                                    </div>

                                }
                            </div>
                        )
                    }}
                </Query>
            </DocumentTitle>
        )
    }
}

export default Dashboard



// WEBPACK FOOTER //
// ./src/components/Dashboard.jsx